import { z } from 'zod';
import { suretyTypeSchema } from '../../../../enums.mjs';
import '../../../../types/actor/actor.mjs';
import '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { carrierName } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/bonding-line.mjs';
import '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import { currencySchema } from '../../../../types/utils.mjs';

const exposureDetailSchema = z.object({
    quotes: z.number(),
    bonds: z.number(),
    total: z.number(),
});
const exposureSchema = z.object({
    bid: exposureDetailSchema,
    bid_to_final: exposureDetailSchema,
    final: exposureDetailSchema,
    total: currencySchema,
});
var Get;
(function (Get) {
    (function (Query) {
        Query.schema = z.object({
            suretyType: suretyTypeSchema.default("contract"),
        });
    })(Get.Query || (Get.Query = {}));
    (function (Response) {
        Response.schema = z.object({ exposure: exposureSchema });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
const committedExposureSchema = z.object({
    open: currencySchema,
    approved: currencySchema,
});
const exposureWithRequestedSchema = committedExposureSchema.extend({
    requested: currencySchema,
});
var Projected;
(function (Projected) {
    (function (Get) {
        (function (Response) {
            Response.schema = z.object({
                category: z.object({
                    bid: exposureWithRequestedSchema,
                    final: exposureWithRequestedSchema,
                }),
                carrier: z.object({
                    placed: z.array(committedExposureSchema.extend({ carrierName })),
                }),
                bySuretyType: z.record(suretyTypeSchema, exposureWithRequestedSchema),
            });
        })(Get.Response || (Get.Response = {}));
    })(Projected.Get || (Projected.Get = {}));
})(Projected || (Projected = {}));

export { Get, Projected };
